export default __webpack_public_path__ + "static/media/img-error-bg.0eedc187.svg";